<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-data-table
								dense
								class="elevation-1"
								:headers="headers"
								:items="privileges"
								hide-default-footer
								:items-per-page="-1"
								group-by="parentID"
								item-key="privilegeID"
							>
								<template #[`item.privilegeValue`]="{ item }">
									<v-switch
										v-if="parentPrivs[item.parentID].privilegeValue"
										v-model="item.privilegeValue"
										hide-details
										class="pa-0 ma-0"
										:disabled="!privs.editPrivileges || loading"
										:loading="item.loading"
										@click="updatePrivilege(item)"
									></v-switch>
								</template>

								<template #[`item.name`]="{ item }">
									<div v-if="item.isEdit">
										<v-text-field v-model="item.name" :disabled="item.isLoading"></v-text-field>
									</div>
									<div v-else>{{ item.name }}</div>
								</template>

								<template #[`item.description`]="{ item }">
									<div v-if="item.isEdit">
										<v-text-field v-model="item.description" :disabled="item.isLoading"></v-text-field>
									</div>
									<div v-else>{{ item.description }}</div>
								</template>

								<template #[`item.defaultValue`]="{ item }">
									<v-switch v-model="item.defaultValue" :disabled="item.isLoading || !item.isEdit" :true-value="1" :false-value="0" hide-details class="mt-0"></v-switch>
								</template>

								<template #[`item.actions`]="{ item }">
									<v-tooltip v-if="item.isEdit == false" bottom>
										<template #activator=" {on} ">
											<v-btn icon medium :disabled="!privs.manage || item.isLoading" v-on="on" @click="enableEditPrivilege(item)">
												<v-icon color="primary">mdi-comment-edit</v-icon>
											</v-btn>
										</template>
										<span>تحرير</span>
									</v-tooltip>

									<v-tooltip v-else bottom>
										<template #activator=" {on} ">
											<v-btn icon medium :disabled="!privs.manage || item.isLoading" v-on="on" @click="enableEditPrivilege(item)">
												<v-icon color="success">mdi-comment-check</v-icon>
											</v-btn>
										</template>
										<span>حفظ</span>
									</v-tooltip>
								</template>

								<template #[`group.header`]="{ group, toggle, isOpen }">
									<td class="text-start blue lighten-4">
										<v-icon v-if="isOpen" @click="toggle">mdi-minus</v-icon>
										<v-icon v-else @click="toggle">mdi-plus</v-icon>
										{{ parentPrivs[group].privilegeID }}
									</td>
									<td class="text-start blue lighten-4">
										<div v-if="parentPrivs[group].isEdit">
											<v-text-field v-model="parentPrivs[group].name" :disabled="parentPrivs[group].isLoading"></v-text-field>
										</div>
										<div v-else>{{ parentPrivs[group].name }}</div>
									</td>
									<td class="text-start blue lighten-4">
										<div v-if="parentPrivs[group].isEdit">
											<v-text-field v-model="parentPrivs[group].description" :disabled="parentPrivs[group].isLoading"></v-text-field>
										</div>
										<div v-else>{{ parentPrivs[group].description }}</div>
									</td>
									<td class="blue lighten-4">
										<v-switch v-model="parentPrivs[group].defaultValue" :disabled="parentPrivs[group].isLoading || !parentPrivs[group].isEdit" :true-value="1" :false-value="0" hide-details class="mt-0"></v-switch>
									</td>
									<td class="text-end blue lighten-4">
										<v-tooltip v-if="parentPrivs[group].isEdit == false" bottom>
											<template #activator=" {on} ">
												<v-btn icon medium :disabled="!privs.manage || parentPrivs[group].isLoading" v-on="on" @click="enableEditPrivilege(parentPrivs[group])">
													<v-icon color="primary">mdi-comment-edit</v-icon>
												</v-btn>
											</template>
											<span>تحرير</span>
										</v-tooltip>

										<v-tooltip v-else bottom>
											<template #activator=" {on} ">
												<v-btn icon medium :disabled="!privs.manage || parentPrivs[group].isLoading" v-on="on" @click="enableEditPrivilege(parentPrivs[group])">
													<v-icon color="success">mdi-comment-check</v-icon>
												</v-btn>
											</template>
											<span>حفظ</span>
										</v-tooltip>
									</td>
								</template>
							</v-data-table>

							<!-- <v-data-table hide-default-footer :headers="headers" :items="privileges" :items-per-page="-1" dense>
								
							</v-data-table> -->
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ 
					text: "إعداد بيانات الصلاحيات",
					disabled: true 
				}
			],
			loading: true,
			
			privileges: [],
			parentPrivs: {},

			headers: [
				{ value: "privilegeID", text: "نوع الإتصال" },
				{ value: "name", text: "الاسم" },
				{ value: "description", text: "الوصف" },
				{ value: "defaultValue", text: "القيمة الافتراضية" },
				{ value: "actions", text: "عمليات", align: "end" }
			],
		};
	},
	mounted() {
		this.getPrivileges();
		this.getInfo();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/privilegeIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getInfo() {
			client
				.get("/api/privilege/index")
				.then(response => {
					const info = response.data.data.map(privilege => {
						privilege.isEdit = false;
						privilege.isLoading = false;
						return privilege
					})

					var privs = info.map(p => {
						if (p.parentID == undefined) {
							p.parentID = "ROOT";
						}
						return p;
					});
					this.privileges = privs.filter(p => p.parentID != "ROOT");

					var rootPrivs = privs
						.filter(p => p.parentID == "ROOT")
						.map(p => {
							p.loading = false;
							return p;
						});
					rootPrivs.forEach(priv => {
						this.parentPrivs[priv.privilegeID] = priv;
						this.parentPrivs[priv.privilegeID].isEdit = false;
						this.parentPrivs[priv.privilegeID].isLoading = false;
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateInfo(item) {
			item.isLoading = true;
			if (!item.description) {
				item.description = '-';
			}

			clientNotifier
				.post("/api/privilege/update", item)
				.then(() => {
					item.isEdit = false;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		enableEditPrivilege(item) {
			console.log(item)
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.isEdit = true;
				this.$forceUpdate();
			}
		},
	}
};
</script>